﻿﻿import { ILogisticsOptionNote } from './logistics-option-note';
import { ILogisticsOption } from './logistics-option';

export interface ILogisticsOptionRequest {
    chainId: number;
    clusterNumber: number;
    positionNumber: number;
    logisticsProvider: number;
    recipientId: number;
    donorId: number;
    deadline: string;
    notes: ILogisticsOptionNote[];
    options: ILogisticsOption[];
}
